export default {"src":"https://assets.willie.be/003a5d6bcce39278/_next/static/media/box.463cf361.svg","height":32,"width":30,"blurWidth":0,"blurHeight":0};